import React, { useState, useEffect } from "react";
import airplane from "../assets/airplane.svg";
import Check from "../assets/check.svg";
import Mobile from "is-mobile";

const Mob = Mobile();
const TextInput = (props) => {
  const [email, setEmail] = useState("");

  return (
    <>
      <div
        style={{
          position: "relative",
          zIndex: 10,
        }}
      >
        <div className="wrapper">
          <input
            className="textInput"
            value={props.email}
            placeholder="Enter email address"
            onChange={(e) => props.action(e.target.value)}
          />
          <button className="button" onClick={props.submit}>
            {props.isLoading ? "Accessing.." : "GET EARLY ACCESS"}
          </button>
          {/* <div
            className="button"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span class="lds-dual-ring"></span>
          </div> */}
          {/* <button className="buttonCheck">
            <img src={Check} width="15" height="15" />
          </button> */}
        </div>
        <img src={airplane} width="30" height="30" className="airplane" />
      </div>
    </>
  );
};

export default TextInput;
